const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/** A ULID (time-ordered, 80 random bits) from Web Crypto, usable in browsers and Workers. */
export function ulid(now: number = Date.now()): string {
  let time = '';
  let t = now;
  for (let i = 0; i < 10; i++) {
    time = CROCKFORD[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  let random = '';
  for (let i = 0; i < 16; i++) random += CROCKFORD[bytes[i]! % 32];
  return time + random;
}

export const newSubmissionId = () => `sub_${ulid()}`;
export const newJourneyId = () => `jny_${ulid()}`;

export const SUBMISSION_ID_PATTERN = /^sub_[0-9A-HJKMNP-TV-Z]{26}$/;
export const JOURNEY_ID_PATTERN = /^jny_[0-9A-HJKMNP-TV-Z]{26}$/;

export function dealKey(submissionId: string, ordinal: number): string {
  return ordinal === 0 ? `${submissionId}:check` : `${submissionId}:hire:${ordinal}`;
}

/** Companies House numbers are 8 characters: digits, or a 2-letter prefix and 6 digits. */
export function canonicalCompanyNumber(raw: string): string | null {
  const compact = raw.replace(/\s+/g, '').toUpperCase();
  if (/^\d{1,8}$/.test(compact)) return compact.padStart(8, '0');
  if (/^[A-Z]{2}\d{1,6}$/.test(compact)) return compact.slice(0, 2) + compact.slice(2).padStart(6, '0');
  if (/^[A-Z]{2}\d{5}[A-Z]$/.test(compact)) return compact;
  return null;
}

export function companyKey(companyNumber: string | null, companyName: string): string {
  if (companyNumber) return `ch:${companyNumber}`;
  return `name:${companyName.trim().toLowerCase().replace(/\s+/g, ' ')}`;
}
